import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { CalculationService, DataService, DateService, HelperService, HTTPService, ValidationService } from 'app/services';
import { config, messages, paymentTypes } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { currency } from 'app/constants/currency.constants';
import { PayrixPaymentFieldComponent } from '../payment-add/payrix-payment-field/payrix-payment-field.component';

import { environment } from 'environments/environment';

import { orderBy, sortBy, sum } from 'lodash';
import { GlobalPaymentFieldComponent } from '../payment-add/global-payment-field/global-payment-field.component';

@Component({
  selector: 'app-create-bulk-payment-dialog',
  templateUrl: './create-bulk-payment-dialog.component.html',
  styleUrls: ['./create-bulk-payment-dialog.component.scss'],
  providers: [DialogService],
})
export class CreateBulkPaymentDialogComponent implements OnInit {
  isArchived: boolean;
  estimateSearchResults: any[] = [];
  customerSearchResults: any[] = [];
  paymentMethods: any[] = [];
  cashPaymentMethods: any[] = [];
  cardPaymentMethods: any[] = [];
  otherPaymentMethods: any[] = [];
  defaultTitle: string = config.defaultTitle;
  noCustomerText: string = config.noCustomerTitle;
  noEmailText: string = config.noEmail;
  usd = currency.USD;
  selectedPaymentMethod: any = {};
  previousCollectedAmount: number = 0;
  validate: any = {};
  remainingBalance: any = 0;
  paymentId: any;
  reviewConfiguration: any;
  isLoadingResults: boolean = true;
  disabled: boolean = false;
  workFlowDisabled: boolean = false;
  isProcessing: boolean = false;
  isNewPayment: boolean = true;
  isOrderEditable: boolean = true;
  isCustomerEditable: boolean = true;
  paymentHistory: any = [];
  focus: any = { collectedAmount: false };
  paymentTypes: any[] = paymentTypes;
  paymentMethodsActive = {
    cheque: true,
    cash: true,
    card: true,
  };
  payRixResponse: any = {};
  maxDateRange: any = new Date();
  activePayment: any = this.paymentTypes[0];
  payment: any = {
    _id: '',
    title: '',
    code: '',
    payRixResponse: this.payRixResponse,
    paymentType: this.activePayment.value,
    collectedAmount: null,
    method: {
      methodId: '',
      qboId: '',
      name: '',
      type: '',
    },
    cardType: '',
    card4Digits: '',
    cardConfNo: '',
    checkNo: '',
    notes: '',
  };
  isSearching: boolean = false;
  paymentTime: any = '';
  isQboConnected: any = false;
  collectedAmmount: any;
  confirmCardPattern: any = { '0': { pattern: new RegExp('[a-zA-Z0-9]') } };
  isConfigLoading: boolean = false;
  isPaymentLoading: boolean = false;
  isMethodLoading: boolean = false;
  statementId: string = '';
  customerId: string = '';
  statement: any = {};
  selectedInvoices: any = {};
  invoicesCodes: string = '';
  isInvoiceLoading: boolean = false;
  statementTotal = {
    total: 0,
    paid: 0,
    due: 0,
    count: 0,
    applied: 0,
    notApplied: 0,
    priorAppliedPayment: 0,
  };
  tableCheckState: number = 0;
  cols: any[] = [
    {
      field: 'invCode',
      header: 'Invoice#',
      isShowSortIcon: false,
      className: 'inv-code',
    },
    {
      field: 'vehicle',
      header: 'Vehicle',
      isShowSortIcon: false,
      className: 'vehicle',
    },
    {
      field: 'invoiceDate',
      header: 'Invoiced Date',
      isShowSortIcon: false,
      className: 'invoice-date',
    },
    {
      field: 'paymentStatus',
      header: 'Status',
      isShowSortIcon: false,
      className: 'payment-status',
    },
    {
      field: 'totalOrderAmount',
      header: 'Total value',
      isShowSortIcon: false,
      className: 'total-value',
    },
    {
      field: 'priorUnappliedPayment',
      header: 'Prior unapplied payments',
      isShowSortIcon: false,
      className: 'prior-unapplied-payment',
    },
    {
      field: 'amountRemaning',
      header: 'Balance due',
      isShowSortIcon: false,
      className: 'amount-remaning',
    },
    {
      field: 'payment',
      header: 'Payment',
      isShowSortIcon: false,
      className: 'payment',
    },
  ];
  statementList: any[] = [];
  isPayrix: boolean = false;
  isOnlineCard: boolean = false;
  isPayrixConnected: boolean = false;
  isLockOrderEnabled: boolean = false;
  isCustomerPaymentEnabled: boolean = false;
  featureIsPayRixEnable: boolean = false;
  isGlobalPayEnabled: boolean = false;
  isGlobalPayConnected: boolean = false;
  afterOnlinePayment = false;
  isPaymentOnline = false;
  isPaymentGatewayConected: boolean = false;
  isRevenueRecognitionSettleEnabled : boolean  = false;
  payrixPaymentMethod: any[] = [];
  opening = false;
  validateError: boolean = false;
  company = {};
  globalPaymentResponse: any = {};
  // Create bulk payment
  showNotesAndPaymentMethod: any;
  changePaymentData: boolean = false;
  isPaymentDataPrivilgesEnabled: boolean = false;
  bulkPaymentType: string = 'statement';
  unappliedAmount: number = 0;

  private merchantId: any;
  private apiKey: any;
  private credentials: any;

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    public validationService: ValidationService,
    public dataService: DataService,
    public dateService: DateService,
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private calculationService: CalculationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const data = this.dConfig.data;

    this.setFeatureFlag();

    if (data.customerId) {
      this.customerId = data.customerId;

      if (this.isCustomerPaymentEnabled) {
        this.getCustomer();
      }

      this.getStatements();
    }

    if (data.bulkPaymentId) {
      this.paymentId = data.bulkPaymentId;
      this.getBulkPaymentById();
    } else if (data.statementId) {
      this.statementId = data.statementId;
      this.getStatementById();
    }

    this.fetchPaymentMethods();
    this.getInitDetails();
  }

  setFeatureFlag() {
    this.isQboConnected = this.helperService.getCompany().qbo;
    this.isLockOrderEnabled = this.dataService.isLockOrderEnabled;
    this.isCustomerPaymentEnabled = this.dataService.isCustomerPaymentEnabled;
    this.changePaymentData = this.dataService.changePaymentData;
    this.isPaymentDataPrivilgesEnabled = this.dataService.isPaymentDataPrivilgesEnabled;
    this.isRevenueRecognitionSettleEnabled = this.dataService.isRevenueRecognitionSettleEnabled;

    if(this.isRevenueRecognitionSettleEnabled){
      this.cols.map((col) => {
        if(col.field==='invoiceDate'){
          col.field='finalizeDate';
          col.header='Finalized Date';
        }
      })
    }
  }

  getInitDetails() {
    this.httpService.initUserAppData().then((res: any) => {
      if (res?.length) {
        const settings = res[0];
        const updatedSettings = res[2];
        this.isPayrixConnected = settings?.appsettings?.isPayrixConnected;
        this.isGlobalPayConnected = updatedSettings.isGlobalPayConnected;
        //  shop level
        if (res[1]?.currentShopId?.appsettings?.primaryPaymentProvider === 'payrix') {
          this.featureIsPayRixEnable = true;
        } else if (res[1]?.currentShopId?.appsettings?.primaryPaymentProvider === 'globalPay') {
          this.isGlobalPayEnabled = true;
        } else {
          this.featureIsPayRixEnable = false;
          this.isGlobalPayEnabled = false;
        }
        this.company = res;
        if (this.featureIsPayRixEnable && this.isPayrixConnected) {
          // get info of payrix
          this.getInfoPayrix();
        } else if (this.isGlobalPayConnected && this.isGlobalPayEnabled) {
          // get info global payment
          this.getInfoGlobalPay();
        }
      }
    });
  }

  getInfoGlobalPay() {
    this.httpService
      .getGlobalPaymentInfo()
      .then((e: any) => {
        if (e) {
          const data = this.helperService.decryptPaymentData(e.hash);
          this.credentials = data;
          this.payrixPaymentMethod = e.paymentMethods;
        }
      })
      .catch((err) => {
        this.isPayrixConnected = false;
        console.log(err);
      });
  }

  getInfoPayrix() {
    this.httpService
      .getPayrixInfo()
      .then((e) => {
        if (e) {
          const data = this.helperService.decryptPaymentData(e.hash);
          this.merchantId = data.merchantId;
          this.apiKey = data.apiKey;
          this.payrixPaymentMethod = e.paymentMethods;
        }
      })
      .catch((err) => {
        this.isPayrixConnected = false;
        console.log(err);
      });
  }

  // Getting statment
  getStatementById() {
    this.httpService.getStatementById(this.statementId, true, true, false).then(
      ({ statement, serverTime }) => {
        if (statement && statement._id) {
          this.statement = statement;
          this.setStatementData();
          const currentTime = this.dateService.getCurrentDateTimeTz(serverTime);
          this.payment.paymentDate = currentTime;
          this.paymentTime = currentTime;
          this.calculateRemainingBalance();
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  getBulkPaymentById() {
    if (!this.paymentId) return;

    this.httpService.getBulkPaymentById(this.paymentId).then(
      ({ bulkPayment }) => {
        if (bulkPayment && bulkPayment._id) {
          this.statement = bulkPayment.statementId;
          this.previousCollectedAmount = bulkPayment.amountCollected;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  getStatements() {
    this.httpService.getStatementList({ isBasicList: true, customerId: this.customerId }).then(
      (statements) => {
        this.statementList = statements;
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  getCustomer() {
    this.httpService.getCustomerPayments(this.customerId, { resultType: 'total' }).then(
      (unappliedAmount: any) => {
        this.unappliedAmount = unappliedAmount;
        this.calculateRemainingBalance();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  getOutstandingInvoices() {
    this.httpService.getOutstandingInvoices(this.customerId, { resultType: 'total' }).then(
      (data: any) => {
        console.log(data);
        const currentTime = this.dateService.getCurrentDateTimeTz(data.serverTime);
        this.statement = {
          _id: 'roa',
          customer: { ...data.customer, customerId: data.customer._id },
          invoices: data.invoices,
        };
        this.setStatementData();
        this.payment.paymentDate = currentTime;
        this.paymentTime = currentTime;
        this.calculateRemainingBalance();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleSelectStatement(statement: any) {
    this.statementId = statement._id;
    this.statementTotal = {
      total: 0,
      paid: 0,
      due: 0,
      count: 0,
      applied: 0,
      notApplied: 0,
      priorAppliedPayment: 0,
    };
    this.invoicesCodes = '';
    this.statement = {};
    this.previousCollectedAmount = 0;
    this.selectedInvoices = {};
    this.getStatementById();
  }

  // Setting statement data and selected invoices
  setStatementData() {
    if (this.statement?._id) {
      const sortByKey = this.isRevenueRecognitionSettleEnabled ? 'finalizeDate' : 'invoiceDate';
      this.statement.invoices = orderBy(this.statement.invoices, [sortByKey], 'asc' );
      this.statement.invoices.forEach((invoice: any) => {
        invoice.paid = sum([
          this.calculationService.roundOff(invoice.card),
          this.calculationService.roundOff(invoice.cheque),
          this.calculationService.roundOff(invoice.cash),
          this.calculationService.roundOff(invoice.creditPayment),
          this.calculationService.roundOff(invoice.thirdParty),
        ]);
        invoice.amountRemaning = this.calculationService.roundOff(invoice.total.grand - invoice.paid);
        invoice.totalOrderAmount = invoice.total.grand;
        this.selectedInvoices[invoice._id] = invoice;

        if (invoice.restriction) {
          const { status, token } = invoice.restriction;
          invoice.isRestricted = status === 'restricted';
        } else {
          invoice.isRestricted = false;
        }

        if (invoice.isPaidFull) {
          invoice.paymentStatus = 'Paid';
        } else {
          invoice.paymentStatus = invoice.isPaidPartial ? 'Partially paid' : 'Unpaid';
        }
      });

      this.calculateStatementTotal();
    }
  }

  // Calculating total for selected invoices
  calculateStatementTotal() {
    this.statementTotal = {
      ...this.statementTotal,
      count: 0,
      total: 0,
      paid: 0,
      due: 0,
    };
    const orderCodes = [];
    const sortedOrder: any = sortBy(Object.values(this.selectedInvoices), 'invoiceDate');

    sortedOrder.forEach((order: any) => {
      const paid = sum([
        this.calculationService.roundOff(order.card),
        this.calculationService.roundOff(order.cheque),
        this.calculationService.roundOff(order.cash),
        this.calculationService.roundOff(order.creditPayment),
        this.calculationService.roundOff(order.thirdParty),
      ]);

      this.statementTotal.total = this.calculationService.roundOff(this.statementTotal.total + order.total.grand);
      this.statementTotal.due = this.calculationService.roundOff(this.statementTotal.due + order.total.grand - paid);
      this.statementTotal.paid = this.calculationService.roundOff(this.statementTotal.paid + paid);
      this.statementTotal.count++;

      if (this.selectedInvoices[order._id]) {
        orderCodes.push(order.code);
      }
    });

    this.invoicesCodes = `RO# ${orderCodes.join(', ')}`;

    // if (sortedOrder[0]) {
    //   this.statementRange.start = sortedOrder[0].invoiceDate;
    //   this.statementRange.end = sortedOrder[sortedOrder.length - 1].invoiceDate;
    // }

    for (let i = 0; i < this.statement.invoices.length; i++) {
      const { _id } = this.statement.invoices[i];

      if (!this.selectedInvoices[_id]) {
        this.tableCheckState = Object.keys(this.selectedInvoices).length === 0 ? 0 : 1;
        return;
      }
    }

    this.tableCheckState = 2;
  }

  // Handling indivisual statement selection
  handleStatementSelect(data: any, isChecked: boolean) {
    if (isChecked) {
      this.selectedInvoices[data._id] = data;
    } else {
      delete this.selectedInvoices[data._id];
    }

    this.calculateStatementTotal();
  }

  // Handling all statement selection
  handleAllInvoiceSelect(checkState: number) {
    this.statement.invoices.forEach((data) => {
      if (checkState === 0 || checkState === 1) {
        this.selectedInvoices[data._id] = data;
      } else {
        delete this.selectedInvoices[data._id];
      }
    });

    this.calculateStatementTotal();
  }

  // Opening invoices in new tab
  openInvoice(invoiceId: string) {
    if (!invoiceId) return;

    this.helperService.openPageInNewExistingTab(`/estimate/${invoiceId}`, invoiceId);
  }

  // Getting amounts from input boxes
  handleChange(value: any, field: string) {
    if (field === 'collectedAmount') {
      this.payment[field] = !isNaN(value.replace(',', '')) ? Number(value.replace(',', '')) : value;
    } else if (!['card4Digits', 'cardConfNo', 'checkNo', 'notes'].includes(field)) {
      this.payment[field] = Number(value);
    } else {
      this.payment[field] = value;
    }

    this.calculateRemainingBalance();
  }

  // Calculating remaining amounts
  calculateRemainingAmount() {
    const { total, paid } = this.statementTotal;
    const { collectedAmount = 0 } = this.payment;
    // const collectedAmount = this.payment.collectedAmount + this.unappliedAmount;
    let remaining = 0;

    if (this.paymentId) {
      remaining = total + this.previousCollectedAmount - (collectedAmount + paid);
    } else {
      remaining = total - (collectedAmount + paid);
    }

    if (this.statementTotal.priorAppliedPayment) {
      remaining = remaining - this.statementTotal.priorAppliedPayment;
    }

    return this.calculationService.roundOff(remaining);
  }

  // Calculating remaining amounts
  calculateRemainingBalance() {
    const { collectedAmount = 0 } = this.payment;
    // const collectedAmount = this.payment.collectedAmount + this.unappliedAmount;
    // const remainingAmount = this.calculateRemainingAmount();

    if (!this.isCustomerPaymentEnabled && collectedAmount > this.calculationService.roundOff(this.statementTotal.due)) {
      this.validateError = true;
      this.validate.amount = '* Amount must be less than the remaining balance';
    } else {
      this.validateError = false;
      this.validate.amount = '';
    }

    this.remainingBalance = this.calculateRemainingAmount();
    this.statementTotal.priorAppliedPayment = 0;

    if (collectedAmount <= this.statementTotal.total) {
      this.statementTotal.applied = collectedAmount;
      this.statementTotal.notApplied = 0;
    } else {
      this.statementTotal.applied = this.statementTotal.total;
      this.statementTotal.notApplied = collectedAmount - this.statementTotal.total;
    }

    const invoiceIds = Object.keys(this.selectedInvoices);
    let amountLeftToAddInOrder = collectedAmount;
    let priorAmountLeftAfterApplying = this.unappliedAmount;

    //check if the statement has invoices otherwise got the undefined error on length property
    if (this.statement?.invoices) {
      // Applying prior payments
      for (let i = 0; i < this.statement.invoices.length; i++) {
        const { _id, total, cheque, card, cash, creditPayment, thirdParty } = this.statement.invoices[i];
        const unpaid = total.grand - sum([cheque, card, cash, creditPayment, thirdParty]);

        if (invoiceIds.includes(_id)) {
          if (priorAmountLeftAfterApplying >= unpaid) {
            this.statement.invoices[i].priorPayment = unpaid;
            priorAmountLeftAfterApplying -= unpaid;
          } else {
            this.statement.invoices[i].priorPayment = priorAmountLeftAfterApplying;
            priorAmountLeftAfterApplying = 0;
          }

          this.statementTotal.priorAppliedPayment += this.statement.invoices[i].priorPayment;
          this.statement.invoices[i].amountRemainingAfterPriorPayment = unpaid - this.statement.invoices[i].priorPayment;
        }
      }

      // Applying new payments
      for (let i = 0; i < this.statement.invoices.length; i++) {
        const { _id, total, cheque, card, cash, creditPayment, thirdParty, priorPayment = 0 } = this.statement.invoices[i];
        const unpaid = total.grand - sum([cheque, card, cash, creditPayment, thirdParty, priorPayment]);

        if (invoiceIds.includes(_id)) {
          if (amountLeftToAddInOrder >= unpaid) {
            this.statement.invoices[i].payment = unpaid;
            amountLeftToAddInOrder -= unpaid;
          } else {
            this.statement.invoices[i].payment = amountLeftToAddInOrder;
            amountLeftToAddInOrder = 0;
          }
        }
      }
    }

    this.remainingBalance = this.calculateRemainingAmount();
  }

  onCardTypeSelect(card: any) {
    this.payment.cardType = card.name;
    this.selectedPaymentMethod = card;
  }

  onDateTimeChange(date: any) {
    this.payment.paymentDate = date;
  }

  closePaymentModal(data: any, isRefreshStatement?) {
    this.dataService.sendData(this.dataService.typePassData('statement-list-refresh', {}));
    if (isRefreshStatement) {
      this.dataService.sendData(this.dataService.typePassData('statement-list', {}));
    }
    this.ref.close(data);
  }

  handleFocus(key: string) {
    this.focus[key] = true;
    this.validate.amount = '';
  }

  handleBlur(key: string) {
    this.focus[key] = false;
    //to avoid NaN for the '.' by coverting it to zero if foucs out after only adding the '.'
    if (this.payment.collectedAmount === '.') {
      this.payment.collectedAmount = 0;
      if (this.statement && this.statement.invoices) {
        for (let i = 0; i < this.statement.invoices.length; i++) {
          if (this.statement.invoices[i].payment === '.') {
            this.statement.invoices[i].payment = 0;
            break;
          }
        }
      }
    }
  }

  setPaymentMethod() {
    if (this.payment.paymentMethod && this.payment.paymentMethod.methodId && this.paymentMethods.length) {
      const [paymentMethod] = this.paymentMethods.filter(({ _id }) => _id === this.payment.paymentMethod.methodId);
      const [activePaymentType] = this.paymentTypes.filter(({ value }) => this.payment.paymentType === value);

      if (paymentMethod && activePaymentType) {
        this.selectedPaymentMethod = paymentMethod;
        this.activateMethodCard(activePaymentType);
      }
    }
  }

  activateMethodCard(method: any, changed = false) {
    if (this.afterOnlinePayment) {
      return;
    }
    if (method.value === 'card') {
      if ((this.featureIsPayRixEnable && this.isPayrixConnected) || (this.isGlobalPayEnabled && this.isGlobalPayConnected)) {
        this.isPaymentGatewayConected = true;
        this.isPaymentOnline = true;
      }
      if (this.isPaymentOnline && this.isPaymentGatewayConected) {
        this.showNotesAndPaymentMethod = false;
      } else {
        this.showNotesAndPaymentMethod = true;
      }
      this.paymentMethods = [...this.cardPaymentMethods];
    } else if (method.value === 'cash') {
      this.isPaymentOnline = false;
      this.showNotesAndPaymentMethod = true;
      this.paymentMethods = [...this.cashPaymentMethods];
    } else {
      this.isPaymentOnline = false;
      this.showNotesAndPaymentMethod = true;
      this.paymentMethods = [...this.otherPaymentMethods];
    }

    if (this.paymentMethods.length) {
      this.activePayment = method;
      if (changed) {
        this.selectedPaymentMethod = this.paymentMethods[0];
      }
    }
  }

  /** Fetch payments and set the qboId for the non credit card payment */
  fetchPaymentMethods() {
    if (!environment.isMock) {
      this.isMethodLoading = true;
      this.httpService.getActivePaymentMethods().then(
        (paymentMethods: any[]) => {
          this.paymentMethods = paymentMethods.filter(({ integrationType }) => integrationType !== 'payrix');
          this.payrixPaymentMethod = paymentMethods.filter(({ integrationType }) => integrationType === 'payrix');

          paymentMethods.forEach((method) => {
            if (method.type === 'CREDIT_CARD') {
              this.cardPaymentMethods.push(method);
            } else if (method.type === 'CASH' && !this.isQboConnected) {
              this.cashPaymentMethods.push(method);
            } else if (method.name.toLowerCase().includes('cash') && this.isQboConnected) {
              this.cashPaymentMethods.push(method);
            } else {
              this.otherPaymentMethods.push(method);
            }
          });

          this.paymentMethodsActive = {
            card: !!this.cardPaymentMethods.length,
            cash: !!this.cashPaymentMethods.length,
            cheque: !!this.otherPaymentMethods.length,
          };

          if (!this.paymentId && this.cashPaymentMethods.length) {
            this.selectedPaymentMethod = this.cashPaymentMethods[0];
            this.activateMethodCard(this.paymentTypes[0]);
          }

          if (!this.paymentId) {
            if (this.cashPaymentMethods.length) {
              this.selectedPaymentMethod = this.cashPaymentMethods[0];
              this.activateMethodCard(this.paymentTypes[0]);
            } else if (this.cardPaymentMethods.length) {
              this.selectedPaymentMethod = this.cardPaymentMethods[0];
              this.activateMethodCard(this.paymentTypes[1]);
            } else if (this.otherPaymentMethods.length) {
              this.selectedPaymentMethod = this.otherPaymentMethods[0];
              this.activateMethodCard(this.paymentTypes[2]);
            }
          }
          this.isMethodLoading = false;
          this.setPaymentMethod();
        },
        (err) => {
          this.isMethodLoading = false;
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  /** Validate payment data */
  validation() {
    let isFormValid = true;

    if (!Object.keys(this.selectedInvoices).length) {
      this.helperService.showToaster('error', 'Please select an invoice');
      isFormValid = false;
    }

    if (this.statementTotal.notApplied !== 0 && !this.isCustomerPaymentEnabled) {
      this.helperService.showToaster('error', '* Amount must be less than the remaining balance');
      isFormValid = false;
    }

    return isFormValid;
  }

  onSubmit(isForced: boolean = false) {
    //  need to just close bulkPayment modal after payrix payment success.
    if (isForced && this.afterOnlinePayment) {
      this.closePaymentModal(null, true);
    } else {
      if (!this.validation() || this.isProcessing || this.isConfigLoading || this.isPaymentLoading || this.isMethodLoading) {
        return;
      }
      if (this.activePayment.value === 'card' && this.isPaymentOnline && !this.afterOnlinePayment && !this.paymentId) {
        this.helperService.showToaster('error', 'Please complete your payment');
        return;
      }

      const date = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmdd);
      const time = this.dateService.formatDate(this.paymentTime, datetimeFormat.hhmm);
      const paymentDate = `${date} ${time}`;
      const payload = {
        paymentMethod: {
          methodId: this.selectedPaymentMethod._id,
          qboId: this.selectedPaymentMethod.qboId,
          name: this.selectedPaymentMethod.name,
          type: this.activePayment.value,
        },
        paymentType: this.activePayment.value,
        paymentDate,
        card4Digits: this.payment.card4Digits,
        cardConfNo: this.payment.cardConfNo,
        cardType: this.payment.cardType,
        checkNo: this.payment.checkNo,
        code: this.payment.amount,
        notes: this.payment.notes,
      };

      const data = {
        payload,
        invoiceIds: Object.keys(this.selectedInvoices),
        statementId: this.statementId,
        statementName: this.statement.name,
        collectedAmount: this.payment.collectedAmount,
        unappliedAmount: this.unappliedAmount,
        customerId: this.statement.customer?.customerId,
        ...this.payRixResponse,
      };

      if (this.statementId) {
        this.createTransaction(data, isForced);
      } else {
        this.createBulkCustomerPayments(data, isForced);
      }
    }
  }

  createTransaction(data: any, isForced?: boolean) {
    if (this.isProcessing) {
      return;
    }
    delete this.payment._id;
    this.isProcessing = true;
    console.log(data);
    this.httpService
      .createBulkPayment(data)
      .then(
        (payment) => {
          if (!isForced) {
            if (this.afterOnlinePayment) {
              this.isProcessing = false;
              this.payment._id = payment._id;
              this.paymentId = this.payment._id;
              return;
            }
          }
          this.helperService.showToaster('success', messages.paymentCreated);
          this.closePaymentModal(null, true);
        },
        (error) => {
          if (error && error.isOrderRestricted) {
            this.helperService.showToaster('error', error.msg);
            this.getStatementById();
          } else {
            this.helperService.showToaster('error', error);
          }
        }
      )
      .finally(() => {
        this.isProcessing = false;
      });
  }

  createBulkCustomerPayments(data: any, isForced?: boolean) {
    if (this.isProcessing) {
      return;
    }
    delete this.payment._id;
    this.isProcessing = true;
    console.log(data);
    this.httpService
      .createBulkCustomerPayments(data)
      .then(
        (payment) => {
          if (!isForced) {
            if (this.afterOnlinePayment) {
              this.isProcessing = false;
              this.payment._id = payment._id;
              this.paymentId = this.payment._id;
              return;
            }
          }
          this.helperService.showToaster('success', messages.paymentCreated);
          this.closePaymentModal(null, true);
        },
        (error) => {
          if (error && error.isOrderRestricted) {
            this.helperService.showToaster('error', error.msg);
            this.getStatementById();
          } else {
            this.helperService.showToaster('error', error);
          }
        }
      )
      .finally(() => {
        this.isProcessing = false;
      });
  }

  paymentMethod(data) {
    if (this.afterOnlinePayment) {
      return;
    } else {
      this.isPaymentOnline = data;
    }

    if (this.isPaymentGatewayConected && this.isPaymentOnline && this.activePayment.value === 'card') {
      this.showNotesAndPaymentMethod = false;
    } else {
      this.showNotesAndPaymentMethod = true;
    }
  }

  //  load payRix script
  openScreen() {
    if (this.featureIsPayRixEnable) {
      // load payrix
      this.payrixPaymentField();
    } else if (this.isGlobalPayConnected) {
      // load GP
      this.gpPaymentField();
    }
  }

  payrixPaymentField() {
    const ref = this.dialogService.open(PayrixPaymentFieldComponent, {
      width: '55%',
      styleClass: 'payrix-dialog',
      showHeader: false,
      data: {
        payment: {
          customer: this.statement.customerId,
          ...this.payment,
          code: this.invoicesCodes.replace('RO#', ''),
        },
        merchantId: this.merchantId,
        apiKey: this.apiKey,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.payRixResponse.payrixResponse = data;
        //  setting payment method;
        if (data.data && data.data[0] && data.data[0].payment && data.data[0].payment.method) {
          const [method] = this.payrixPaymentMethod.filter(({ integrationId }) => `${integrationId}` === `${data.data[0].payment.method}`);

          if (method) {
            this.payRixResponse.payrixResponse.paymentMethod = method.name;
            this.onCardTypeSelect(method);
          }
        }

        this.paymentProcessedCustomEvent(data.payload, data.payload?.paymentProvider || 'payrix');
        // this.payRixResponse.payrixResponse.paymentMethod = payrixPaymentMethod[data.data[0].payment.method];
        this.payment.card4Digits = data.data[0].payment.number;
        this.payment.cardConfNo = data.data[0].authorization;
        this.payment.isOnline = true;
        this.payment.paymentProvider = 'payrix';
        this.afterOnlinePayment = true;
        this.showNotesAndPaymentMethod = true;
        // let obj = this.paymentMethods.find((o) => o.name === this.payRixResponse.payrixResponse.paymentMethod);
        // this.onCardTypeSelect(obj);

        this.onSubmit();
        this.cdr.detectChanges();
      }
      onClose.unsubscribe();
    });
  }

  gpPaymentField() {
    const ref = this.dialogService.open(GlobalPaymentFieldComponent, {
      width: '55%',
      styleClass: 'global-payment-dialog',
      showHeader: false,
      data: {
        globalPaymentMehod: this.payrixPaymentMethod,
        payment: {
          customer: this.statement.customerId,
          ...this.payment,
          code: this.invoicesCodes.replace('RO#', ''),
        },
        merchantId: 'GlobalPay',
        apiKey: 'GlobalPay',
        credentials: this.credentials,
        type: 'bulk',
        statementId: this.statementId,
        statement: this.statement,
        selectedInvoices: this.selectedInvoices,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.globalPaymentResponse = data.globalPayResponse;
        const card = data.card;
        //  setting payment method;
        if (this.globalPaymentResponse) {
          const [method] = this.payrixPaymentMethod.filter(({ name }) => `${name}` === `${this.globalPaymentResponse.cardType}`);

          if (method) {
            this.payment.paymentMethod = this.globalPaymentResponse.cardType;
            this.onCardTypeSelect(method);
          }
        }

        this.helperService.showToaster('success', 'Payment successfully created');
        this.payment.card4Digits = this.globalPaymentResponse.card4Digits;
        this.payment.cardConfNo = this.globalPaymentResponse.cardConfNo;

        // let obj = this.paymentMethods.find((o) => o.name === this.payRixResponse.payrixResponse.paymentMethod);
        // this.onCardTypeSelect(obj);
        this.payment.isOnline = true;
        this.afterOnlinePayment = true;
        this.showNotesAndPaymentMethod = true;
        // let obj = this.paymentMethods.find((o) => o.name === this.payRixResponse.payrixResponse.paymentMethod);
        // this.onCardTypeSelect(obj);

        this.paymentProcessedCustomEvent(data, data?.globalPayResponse);
        this.cdr.detectChanges();
      }
      onClose.unsubscribe();
    });
  }

  paymentProcessedCustomEvent(payment, processor){
    if (this.dataService.isGainSightPXEnabled) {
      const paymentProcessed: any = {
        paymentCreationSource: 'Bulk Payment Modal',
        transactionDateTime: payment?.paymentDate,
        transactionAmount: payment?.collectedAmount,
        roNumber: payment?.code || '',
        customerId: payment?.customer?.customerId || '',
        customerName: payment?.customer?.fullName || '',
        paymentProcessor: processor,
        transactionType: payment?.isOnline ? 'cardOnline' : payment?.isCardSwipe ? 'cardSwipe' : '',
      };
      
      (<any>window).aptrinsic('track', 'Payment Processed', paymentProcessed);
    }
  }

  isStateRestricted() {
    if (!this.isLockOrderEnabled) return false;

    const invoices = (this.statement && this.statement.invoices) || [];

    for (let i = 0; i < invoices.length; i++) {
      const { isRestricted } = invoices[i];

      if (isRestricted) return true;
    }

    return false;
  }

  handleRadioChange(value: string) {
    this.bulkPaymentType = value;
    if (this.bulkPaymentType === 'roa') {
      this.getOutstandingInvoices();
    } else {
      this.statementId = '';
      this.statement = {};
    }
    // console.log(this.bulkPaymentType);
  }
}
